import React, { useEffect, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import AutoScroll from 'embla-carousel-auto-scroll'
import '../styles/EmblaCarousel.css'
// Import images
import image1 from '../assets/clientLogos/Puma-logo-black-Transparent-Background.png'
import image2 from '../assets/clientLogos/Alpha-transparent.png'
import image3 from '../assets/clientLogos/DAZN_transparent_logo.png'
import image4 from '../assets/clientLogos/gsg_logo_transparent.png'
import image5 from '../assets/clientLogos/newsuk_transparent_logo.png'
import image6 from '../assets/clientLogos/DVSA_transparent_logo.png'
import image7 from '../assets/clientLogos/vega_transparent_logo.webp'
import image8 from '../assets/clientLogos/ovo_transparent_logo.png'
import image9 from '../assets/clientLogos/TfGM_transparent_logo.png'
import image10 from '../assets/clientLogos/BBC_Sounds_transprent_logo.png'
import image11 from '../assets/clientLogos/virgin-hols_transparent_background.png'

// Import new client logos
import image12 from '../assets/clientLogos/iohklogo.webp'
import image13 from '../assets/clientLogos/Home_Office-Logo.png'

// Ordered so case-study clients lead the carousel (Puma, DAZN, OVO, Vega,
// GSG, IOHK/Midnight). The remainder follow.
const images = [
  image1,  // Puma
  image3,  // DAZN
  image8,  // OVO
  image7,  // Vega Protocol
  image4,  // Global Savings Group
  image12, // IOHK (Midnight / Cardano)
  image2,  // Alpha
  image5,  // News UK
  image6,  // DVSA
  image9,  // TfGM
  image10, // BBC Sounds
  image11, // Virgin Holidays
  image13, // Home Office
]

const EmblaCarousel = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'start' }, [
    AutoScroll({ playOnInit: true, delay: 500, stopOnInteraction: false }),
  ])
  /* eslint-disable no-unused-vars */
  const [isPlaying, setIsPlaying] = useState(true)

  useEffect(() => {
    const autoScroll = emblaApi?.plugins()?.autoScroll
    if (!autoScroll) return

    setIsPlaying(autoScroll.isPlaying())
    emblaApi
      .on('autoScroll:play', () => setIsPlaying(true))
      .on('autoScroll:stop', () => setIsPlaying(false))
      .on('reInit', () => setIsPlaying(autoScroll.isPlaying()))
  }, [emblaApi])

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {images.map((src, index) => (
            <div className="embla__slide" key={index}>
              <img className="embla__slide__img" src={src} alt={`Slide ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default EmblaCarousel
